import type { Navigator } from '@/shared/navigation';
import { ROUTES, resolvePushRoute } from '@/shared/routing';
import { registerNativeListener } from './client';
import { showPushToast } from './push-toast';

export interface PushBridgeDeps {
  navigator: Navigator;
  /** native 가 발급/갱신한 FCM 토큰. 서버 등록은 호출자(fcm-sync)가 담당. */
  onFcmToken: (token: string) => void;
}

/**
 * Push 브리지 배선 — native → web 이벤트를 앱 동작에 연결한다. composition root 가
 * deps 를 주입해 1회 호출(IoC). 비-native(브라우저)에선 리스너가 등록만 되고 발화하지
 * 않아 무해.
 *
 *   - `push.tokenIssued`        → `onFcmToken` (토큰 등록은 fcm-sync 가 인증 시점과 통합 처리)
 *   - `push.notificationOpened` → 알림 탭 시 목적지 라우트로 navigate (라우팅 SSOT=web)
 */
export function initPushBridge({ navigator, onFcmToken }: PushBridgeDeps): void {
  registerNativeListener('push.tokenIssued', (msg) => {
    onFcmToken(msg.payload.token);
  });

  registerNativeListener('push.notificationOpened', (msg) => {
    // native 는 RemoteMessage.data 원본만 전달 — 코드/URL → 경로 해석은 web 이 담당.
    const route = resolvePushRoute(msg.payload.data);
    navigator.push(route ?? ROUTES.DASHBOARD);
  });

  registerNativeListener('push.received', (msg) => {
    // 앱 포그라운드 수신 → 인앱 토스트(모바일은 FCM 자동표시 안 함). title/body 는 native 가 data 에 합쳐 전달.
    const data = msg.payload.data;
    showPushToast(navigator, { title: data.title, body: data.body, data });
  });
}
